"use strict";

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormOptions = void 0;
var FormOptions;

(function (FormOptions) {
  FormOptions["accessories"] = "ACCESSORIES";
  FormOptions["angle"] = "ANGLE";
  FormOptions["bar"] = "BAR";
  FormOptions["bushing"] = "BUSHING";
  FormOptions["cap"] = "CAP";
  FormOptions["carbon"] = "CARBON";
  FormOptions["channelPlankGrating"] = "CHANNEL PLANK GRATING";
  FormOptions["coil"] = "COIL";
  FormOptions["coiledBar"] = "COILED BAR";
  FormOptions["coiledDrawnWire"] = "COILED DRAWN WIRE";
  FormOptions["coiledTread"] = "COILED TREAD";
  FormOptions["coiledTube"] = "COILED TUBE";
  FormOptions["comfab"] = "COMFAB";
  FormOptions["coupling"] = "COUPLING";
  FormOptions["cross"] = "CROSS";
  FormOptions["customProfile"] = "CUSTOM PROFILE";
  FormOptions["cutCoil"] = "CUT COIL";
  FormOptions["elbow"] = "ELBOW";
  FormOptions["expandedMetal"] = "EXPANDED METAL";
  FormOptions["fasteners"] = "FASTENERS";
  FormOptions["finishedPart"] = "FINISHED PART";
  FormOptions["flange"] = "FLANGE";
  FormOptions["flat"] = "FLAT";
  FormOptions["flooring"] = "FLOORING";
  FormOptions["forgedSteel"] = "FORGED STEEL";
  FormOptions["gripStrut"] = "GRIP STRUT";
  FormOptions["insert"] = "INSERT";
  FormOptions["ladderRung"] = "LADDER RUNG";
  FormOptions["lawnEdging"] = "LAWN EDGING";
  FormOptions["misc"] = "MISC";
  FormOptions["nipple"] = "NIPPLE";
  FormOptions["oLet"] = "O LET";
  FormOptions["other"] = "OTHER";
  FormOptions["panel"] = "PANEL";
  FormOptions["perforatedSheet"] = "PERFORATED SHEET";
  FormOptions["pipe"] = "PIPE";
  FormOptions["plate"] = "PLATE";
  FormOptions["plug"] = "PLUG";
  FormOptions["reducer"] = "REDUCER";
  FormOptions["roll"] = "ROLL";
  FormOptions["round"] = "ROUND";
  FormOptions["sheet"] = "SHEET";
  FormOptions["square"] = "SQUARE";
  FormOptions["stainless"] = "STAINLESS";
  FormOptions["stairTread"] = "STAIR TREAD";
  FormOptions["structural"] = "STRUCTURAL";
  FormOptions["stubEnd"] = "STUB END";
  FormOptions["swage"] = "SWAGE";
  FormOptions["tee"] = "TEE";
  FormOptions["treadPlate"] = "TREAD PLATE";
  FormOptions["tube"] = "TUBE";
  FormOptions["union"] = "UNION";
  FormOptions["valve"] = "VALVE";
  FormOptions["weldingSpud"] = "WELDING SPUD";
})(FormOptions || (exports.FormOptions = FormOptions = {}));